import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as staff from './StaffRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({staff: state.staff})
const connector = connect(mapState, staff.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const StaffInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(StaffInit)
